module.exports = __webpack_public_path__ + "img/OTPvsTakt.ed261730.png";